import type { ComponentType, ReactNode } from 'react';
import { Link } from '@tanstack/react-router';

/**
 * Navegação para as telas de fluxo.
 *
 * Mesmo motivo de `features/tickets/navigation.tsx`: o `to` do TanStack Router
 * é tipado contra a árvore registrada em `app/router.tsx`, e este módulo é
 * compilado antes de a rota existir lá. A conversão de tipo fica concentrada
 * aqui, num arquivo só, em vez de espalhada por cada tela.
 */

export const CAMINHO_FLUXOS = '/fluxos';
export const CAMINHO_FLUXO = '/fluxos/$definicaoId';

interface PropsDeLink {
  to: string;
  params?: Record<string, string>;
  className?: string;
  title?: string;
  children: ReactNode;
}

const LinkDeRota = Link as unknown as ComponentType<PropsDeLink>;

export function LinkDoFluxo({
  definicaoId,
  className,
  title,
  children,
}: {
  definicaoId: string;
  className?: string;
  title?: string;
  children: ReactNode;
}) {
  return (
    <LinkDeRota to={CAMINHO_FLUXO} params={{ definicaoId }} className={className} title={title}>
      {children}
    </LinkDeRota>
  );
}

export function LinkDaListaDeFluxos({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <LinkDeRota to={CAMINHO_FLUXOS} className={className}>
      {children}
    </LinkDeRota>
  );
}
